// extracted by mini-css-extract-plugin
export default {"wrapper":"CartButton_wrapper__WAGYx","cartButton":"CartButton_cartButton__5GrHJ","badge":"CartButton_badge__qUr6b"};